import { Thames21LitterItemEnum, Thames21LitterMetricEnum, } from "@cartographerio/inventory-enums";
const ItemEnum = Thames21LitterItemEnum;
const MetricEnum = Thames21LitterMetricEnum;
export function litterItemMetric(item) {
    switch (item) {
        case null:
            return MetricEnum.Count;
        case ItemEnum.FoodPlasticCutlery:
        case ItemEnum.FoodPlasticStraw:
        case ItemEnum.FoodPlasticStirrer:
        case ItemEnum.FoodPlasticLollipopStick:
        case ItemEnum.FoodPlasticFoodWrapper:
        case ItemEnum.FoodPlasticTakeAwayContainer:
        case ItemEnum.FoodPlasticDrinkBottle:
        case ItemEnum.FoodPlasticBottleTop:
        case ItemEnum.FoodPlasticPlasticLid:
        case ItemEnum.FoodPlasticCup:
        case ItemEnum.FoodPlasticPlate:
        case ItemEnum.FoodPlastic6Or4PackRings:
        case ItemEnum.FoodPlasticWineCork:
        case ItemEnum.FoodPlasticHardContainer:
        case ItemEnum.FoodPlasticIcePopContainer:
        case ItemEnum.FoodPlasticOther:
        case ItemEnum.FoodMetalCutlery:
        case ItemEnum.FoodMetalDrinksCan:
        case ItemEnum.FoodMetaltinCan:
        case ItemEnum.FoodMetalBottleTop:
        case ItemEnum.FoodMetalTinFoilWrapping:
        case ItemEnum.FoodMetalOther:
        case ItemEnum.FoodTetraPakDrinkCarton:
        case ItemEnum.FoodTetraPakCoffeeCup:
        case ItemEnum.FoodPaperWoodCorkGlassCupOrPaperPlate:
        case ItemEnum.FoodPaperWoodCorkGlassStirrer:
        case ItemEnum.FoodPaperWoodCorkGlassBottle:
        case ItemEnum.FoodPaperWoodCorkGlassCork:
        case ItemEnum.FoodPolystyreneTakeAwayContainer:
        case ItemEnum.FoodPolystyreneCup:
        case ItemEnum.FoodPolystyreneOther:
        case ItemEnum.FoodOther:
        case ItemEnum.PackagingPlasticThickShoppingBag:
        case ItemEnum.PackagingPlasticThinShoppingBag:
        case ItemEnum.PackagingPlasticRefuseSack:
        case ItemEnum.PackagingPlasticPlasticBottleOrContainer:
        case ItemEnum.PackagingPlasticFoamRoll:
        case ItemEnum.PackagingPlasticOtherPackagingPlastic:
        case ItemEnum.PackagingPlasticOther:
        case ItemEnum.SewageMixedCondom:
        case ItemEnum.SewageMixedTamponOrApplicator:
        case ItemEnum.SewageMixedSanitaryTowel:
        case ItemEnum.SewageMixedCottonBudStick:
        case ItemEnum.SewageMixedNappy:
        case ItemEnum.SewageMixedSyringeOrNeedle:
        case ItemEnum.SewageMixedMedicinePackaging:
        case ItemEnum.SewageMixedWetWipesOrBabyWipes:
        case ItemEnum.SewageMixedPlasticGloves:
        case ItemEnum.SewageMixedEyeDropDispenser:
        case ItemEnum.SewageMixedPlaster:
        case ItemEnum.SewageMixedOther:
        case ItemEnum.SmokingMixedLighter:
        case ItemEnum.SmokingMixedCigaretteButt:
        case ItemEnum.SmokingMixedCigaretteOrTobaccoPackaging:
        case ItemEnum.SmokingMixedOther:
        case ItemEnum.ClothingMixedFaceMask:
        case ItemEnum.ClothingMixedShoe:
        case ItemEnum.ClothingMixedItemOfClothing:
        case ItemEnum.ClothingMixedOther:
        case ItemEnum.MiscMixedRope:
        case ItemEnum.MiscMixedString:
        case ItemEnum.MiscMixedRubberBand:
        case ItemEnum.FishingRecreational:
        case ItemEnum.FishingCommercial:
        case ItemEnum.UnidentifiedPlasticMedium:
        case ItemEnum.UnidentifiedPlasticLarge:
        case ItemEnum.UnidentifiedClothSmall:
        case ItemEnum.UnidentifiedClothMedium:
        case ItemEnum.UnidentifiedClothLarge:
        case ItemEnum.UnidentifiedFoamSmall:
        case ItemEnum.UnidentifiedFoamMedium:
        case ItemEnum.UnidentifiedFoamLarge:
        case ItemEnum.LargeMixedShoppingTrolley:
        case ItemEnum.LargeMixedTyre:
        case ItemEnum.LargeMixedTrafficConeOrSignOrBarrier:
        case ItemEnum.LargeMixedLargeAppliance:
        case ItemEnum.LargeMixedSmallAppliance:
        case ItemEnum.LargeMixedMattress:
        case ItemEnum.LargeMixedCarpet:
        case ItemEnum.LargeMixedOther:
        case ItemEnum.BuildingPlasticBuildingInsulationPieces:
        case ItemEnum.BuildingPlasticCableTie:
        case ItemEnum.BuildingPlasticRawlPlug:
        case ItemEnum.BuildingPlasticWindowSpacerTiles:
        case ItemEnum.BuildingPlasticScaffoldBungee:
        case ItemEnum.BuildingPlasticPipeLagging:
        case ItemEnum.BuildingPlasticTileCrossSpacers:
        case ItemEnum.DomesticPlasticBall:
        case ItemEnum.DomesticPlasticBalloonOrStick:
        case ItemEnum.DomesticPlasticGardening:
        case ItemEnum.DomesticPlasticNerfBullet:
        case ItemEnum.DomesticPlasticPackagingPeanut:
        case ItemEnum.DomesticPlasticPen:
            return MetricEnum.Count;
        case ItemEnum.GlassOther:
        case ItemEnum.MetalOther:
        case ItemEnum.MiscMixedSpecksOfPaint:
        case ItemEnum.MiscNurdles:
            return MetricEnum.Presence;
        case ItemEnum.UnidentifiedPolystyrene:
            return MetricEnum.PolystyreneCover;
        case ItemEnum.UnidentifiedPlasticSmall:
            return MetricEnum.SmallPlasticCount;
    }
}
//# sourceMappingURL=litterItemMetric.js.map